import { useContext } from "react";
import { RegisterContext } from "../contexts/RegisterContext";

export function useRegister() {
  const context = useContext(RegisterContext);

  return context;
}
